type Page = 'sign-in' | 'sign-up'

export const getConfirmCodeLink = (page: Page) => `/${page}/confirm-code`
